var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bc-pill",class:'--' + _vm.tone},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }